import { DEFAULT_DPP_VIDEOS_THUMBNAIL_URL } from 'src/constants/constants';
import { SingleScheduelingDataEnum } from 'src/constants/type';

export class VideoDetails {
  id: string;
  name: string;
  image: string;
  videoUrl: string;
  duration: string;
  status: string;
  types: string[];
  embedCode: string;
  description: string;

  constructor(data: any) {
    data = data || {};
    this.id = data.id || '';
    this.name = data.name || '';
    this.image = data.image || '';
    this.videoUrl = data.videoUrl || '';
    this.duration = data.duration || '';
    this.status = data.status || '';
    this.types = data.types || '';
    this.embedCode = data.embedCode || '';
    this.description = data.description || '';
  }
}

export class Timeline {
  id: string;
  title: string;
  time: number;

  constructor(props: any) {
    props = props || {};
    this.id = props._id || '';
    this.title = props.title || '';
    this.time = props.time || 0;
  }
}
export class Content {
  _id: string;
  timeline: Timeline[];
  videoType: string;
  videoUrl?: any;
  videoDetails: VideoDetails;
  exerciseId: string;

  constructor(data: any) {
    data = data || {};
    this._id = data._id || '';
    this.videoType = data.videoType || '';
    this.videoUrl = data.videoUrl || '';
    this.exerciseId = data.exerciseId || '';
    this.videoDetails = new VideoDetails(data.videoDetails) || new VideoDetails({});

    if (data.timeLine) {
      this.timeline = data.timeLine.map((item: any) => new Timeline(item));
    } else {
      this.timeline = [];
    }
  }
}

export class VideoContentId {
  _id: string;
  content: Content[];

  constructor(data: any) {
    data = data || {};

    this._id = data._id || '';

    if (data.content) {
      this.content = data.content.map((item: any) => new Content(item));
    } else {
      this.content = [];
    }
  }
}

export class AttachmentId {
  baseUrl: string;
  _id: string;
  name: string;
  key: string;

  constructor(data: any) {
    data = data || {};
    this.baseUrl = data.baseUrl || '';
    this._id = data._id || '';
    this.name = data.name || '';
    this.key = data.key || '';
  }
}

export class HomeworkId {
  attachmentIds: AttachmentId[];
  actions: string[];
  _id: string;
  batchSubjectId: string;
  topic: string;
  note: string;
  solutionVideoId: AttachmentId;

  constructor(data: any) {
    data = data || {};

    this.actions = data.actions || [];
    this._id = data._id || '';
    this.batchSubjectId = data.batchSubjectId || '';
    this.topic = data.topic || '';
    this.note = data.note || '';
    this.solutionVideoId = new AttachmentId(data.solutionVideoId) || new AttachmentId({});

    if (data?.attachmentIds?.length > 0) {
      this.attachmentIds = data?.attachmentIds?.map((res: any) => new AttachmentId(res));
    } else {
      this.attachmentIds = [];
    }
  }
}

export class VideoDetailsDataType {
  _id: string;
  name: string;
  image: string;
  thumbnail_url: string;
  embedCode: string;
  hls_url: string;
  videoUrl: string;
  vimeoId: string;
  videoId: string;
  status: string;
  description: string;
  duration: string;
  downloadStatus: string;
  types: Array<string> = [];
  video_id: string;
  vtt_url: string;
  createdAt: string;
  urlType: string;
  publishedAt: string;
  constructor(data: any) {
    const videoDetailData = data || {};
    this.urlType = videoDetailData?.urlType || '';
    this._id = videoDetailData?.id || videoDetailData?._id || '';
    this.name = videoDetailData?.name || '';
    this.image = videoDetailData?.image || DEFAULT_DPP_VIDEOS_THUMBNAIL_URL;
    this.thumbnail_url = videoDetailData?.thumbnail_url || DEFAULT_DPP_VIDEOS_THUMBNAIL_URL;
    this.embedCode = videoDetailData?.embedCode || '';
    this.hls_url = videoDetailData?.hls_url || '';
    this.videoUrl = videoDetailData?.videoUrl || '';
    this.vimeoId = videoDetailData?.vimeoId || '';
    this.videoId = videoDetailData?.videoId || '';
    this.status = videoDetailData?.status || 'ready';
    this.description = videoDetailData?.description || '';
    this.duration = videoDetailData?.duration || '';
    this.downloadStatus = videoDetailData?.downloadStatus || '';
    this.types = videoDetailData?.types || [];
    this.video_id = videoDetailData?.video_id || '';
    this.vtt_url = videoDetailData?.vtt_url || '';
    this.createdAt = videoDetailData?.createdAt || '';
    this.publishedAt = videoDetailData?.publishedAt || '';
  }
}

export class VideoSolDataTypes {
  topic: string;
  videoDetails: VideoDetailsDataType;

  constructor(data: any) {
    const { topic = '', videoDetails = {} } = data;
    if (Object.keys(videoDetails).length <= 0) {
      this.topic = '';
      this.videoDetails = {} as VideoDetailsDataType;
    } else {
      this.topic = topic || '';
      this.videoDetails = new VideoDetailsDataType(videoDetails);
    }
  }
}

export class NotesHomeWorkIds {
  topic: string;
  attachmentIds: AttachmentId[];
  actions: string[];
  constructor(data: any) {
    data = data || {};
    this.topic = data?.topic || '';
    this.actions = data?.actions || [];
    if (data?.attachmentIds?.length > 0) {
      this.attachmentIds = data?.attachmentIds?.map((res: any) => new AttachmentId(res));
    } else {
      this.attachmentIds = [];
    }
  }
}

export class DppSingleScheduling {
  homeworkIds: NotesHomeWorkIds[];
  videoDetails: VideoSolDataTypes;

  constructor(data: any) {
    if (Object.keys(data ?? {}).length <= 0) {
      this.homeworkIds = [];
      this.videoDetails = {} as VideoSolDataTypes;
    } else {
      const dppHomeWorkIds = data?.homeworkIds || [];
      this.homeworkIds =
        dppHomeWorkIds?.length > 0
          ? dppHomeWorkIds?.map((res: any) => new NotesHomeWorkIds(res))
          : [];
      this.videoDetails =
        Object.keys(data?.videoDetails ?? {}).length > 0
          ? new VideoSolDataTypes(data)
          : ({} as VideoSolDataTypes);
    }
  }
}

export class ExerciseId {
  title: string;
  type: string;
  status: string;
  availableFor: any[];
  slug: string;
  content: Content[];
  exerciseDetails: ExerciseDetails;

  constructor(data: any) {
    data = data || {};
    this.title = data.title || '';
    this.type = data.type || '';
    this.status = data.status || '';
    this.availableFor = data.availableFor || [];
    this.slug = data.slug || '';
    this.exerciseDetails = new ExerciseDetails(data.exerciseDetails) || new ExerciseDetails({});

    if (data?.content?.length > 0) {
      this.content = data?.content?.map((res: any) => new Content(res));
    } else {
      this.content = [];
    }
  }
}

export class ExerciseDetails {
  maxDuration: number;
  totalQuestions: number;
  totalMarks: number;

  constructor(data: any) {
    data = data || {};
    this.maxDuration = data.maxDuration || 0;
    this.totalQuestions = data.totalQuestions || 0;
    this.totalMarks = data.totalMarks || 0;
  }
}

export class ContentModel {
  _id: string;
  homeworkIds: HomeworkId[];
  isFree: boolean;
  isDPPNotes: boolean;
  status: string;
  date: string;
  startTime: string;
  dRoomId: string;
  isBatchDoubtEnabled: boolean;
  exerciseIds: ExerciseId[];
  restrictedSchedule: boolean;
  restrictedTime: number;
  urlType: string;
  isChatEnabled: boolean;
  isDoubtEnabled: boolean;
  isCommentDisabled: boolean;
  isPathshala: boolean;
  isDPPVideos: boolean;
  topic: string;
  endTime: string;
  timeline: Timeline[];
  conversationId: string;
  url: string;
  videoDetails: VideoDetails;
  slug: string;
  videoContentId: VideoContentId;
  isLocked: boolean;

  constructor(data: any) {
    data = data || {};

    this._id = data._id || '';
    this.isFree = data.isFree || false;
    this.isDPPNotes = data.isDPPNotes || false;
    this.status = data.status || '';
    this.date = data.date || '';
    this.startTime = data.startTime || '';
    this.dRoomId = data.dRoomId || '';
    this.isBatchDoubtEnabled = data.isBatchDoubtEnabled || false;

    if (data?.homeworkIds?.length > 0) {
      this.homeworkIds = data?.homeworkIds?.map((res: any) => new HomeworkId(res));
    } else {
      this.homeworkIds = [];
    }

    if (data?.exerciseIds?.length > 0) {
      this.exerciseIds = data?.exerciseIds?.map((res: any) => new ExerciseId(res));
    } else {
      this.exerciseIds = [];
    }
    this.restrictedSchedule = data.restrictedSchedule || false;
    this.restrictedTime = data.restrictedTime || 0;
    this.urlType = data.urlType || '';
    this.isChatEnabled = data.isChatEnabled || false;
    this.isDoubtEnabled = data.isDoubtEnabled || false;
    this.isCommentDisabled = data.isCommentDisabled || false;
    this.isPathshala = data.isPathshala || false;
    this.isDPPVideos = data.isDPPVideos || false;
    this.topic = data.topic || '';
    this.endTime = data.endTime || '';
    this.conversationId = data.conversationId || '';
    this.url = data.url || '';
    this.isLocked = data.isLocked || false;
    this.videoDetails = new VideoDetails(data.videoDetails) || new VideoDetails({});
    this.slug = data.slug || '';
    this.videoContentId = new VideoContentId(data.videoContentId) || new VideoContentId({});

    if (data?.timeline) {
      this.timeline = data?.timeline?.map((res: any) => new Timeline(res));
    } else {
      this.timeline = [];
    }
  }
}

export type ExerciseIdsDataType = {
  title: string;
  exerciseId: {
    _id: string;
    displayOrder: number;
    name: string;
    totalMarks: number;
    totalQuestions: number;
    maxDuration: number;
    createdAt: string;
    isSubjective: boolean;
    smartDPP?: boolean;
  };
  tag: string;
  testStudentMapping?: {
    testActivityStatus: string;
    testSource: string;
    _id: string;
  };
};

type SingleSchedulingDataType<T, U> = {
  title: string;
  key: string;
  type: T;
  data: U;
};

export type DppPdfData = SingleSchedulingDataType<
  SingleScheduelingDataEnum.DPP_PDF,
  NotesHomeWorkIds[]
>;

export type DppVideoData = SingleSchedulingDataType<
  SingleScheduelingDataEnum.DPP_VIDEO,
  VideoSolDataTypes[]
>;

export type NotesData = SingleSchedulingDataType<
  SingleScheduelingDataEnum.NOTES,
  NotesHomeWorkIds[]
>;

export type DppData = SingleSchedulingDataType<
  SingleScheduelingDataEnum.DPP,
  ExerciseIdsDataType[]
>;

export type AttachmentDataTypes = DppPdfData | DppVideoData | NotesData | DppData;
